import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { callApi } from '../../apiCaller';
import { CButton, CModal, CModalBody } from '@coreui/react-pro';
import { toastError } from '../../utils';
import { setSubscriberUser } from '../../components/CMS/Subscriber/GlobalStates/CurrentUser/actions';
import { API_ENABLE_TEST_MODE, COOKIE_NAMES, COOKIE_PARAMS, REGEX_LAST_SLASH_CHARACTER } from '../../constants';
import Cookies from 'js-cookie';
import CIcon from '@coreui/icons-react';
import { cilX } from '@coreui/icons';

const PopupEnabledTestMode = () => {
     const dispatch = useDispatch();
     const user = useSelector((state) => state.subscriber.user);
     const [showPopup, setShowPop] = useState(false);

     const url = new URL(window.location.href);
     const isHasFastTestParam = url.searchParams.get(COOKIE_PARAMS.FAST_TESTING)?.replace(REGEX_LAST_SLASH_CHARACTER, '') === 'enabled';

     const isUserTestMode = user?.userTestMode;
     // const isCookieEnabled = Cookies.get(COOKIE_NAMES.FAST_TEST) === 'enabled';

     const handlePopup = () => {
          if (user && !isUserTestMode && isHasFastTestParam) {
               setShowPop(true);
          }
     };
     useEffect(() => {
          handlePopup();
     }, []); // eslint-disable-line react-hooks/exhaustive-deps

     const handleEnabledTestMode = () => {
          const newUser = { userTestMode: true };
          callApi(API_ENABLE_TEST_MODE.replace(':id', user.id), 'PUT', newUser).then((response) => {
               if (response.status !== 200) {
                    toastError(response);
               } else {
                    const newUser = { ...user, userTestMode: true };
                    dispatch(setSubscriberUser(newUser));
                    setShowPop(false);
               }
          });
     };
     const handleCancel = () => {
          setShowPop(false);
          let domain = '';
          switch (process.env.REACT_APP_ENV) {
               case 'prod':
                    domain = 'cams-care.com';
                    break;
               case 'staging':
                    domain = 'hostedstaging.com';
                    break;
               default:
                    break;
          }

          Cookies.remove(COOKIE_NAMES.FAST_TEST, { domain: domain });
     };
     return (
          <CModal alignment="center" visible={showPopup} className="popup-custom enabled-testMode">
               <CModalBody className="text-center">
                    <CIcon icon={cilX} className="icon-close-popup" onClick={handleCancel}></CIcon>
                    <div className="d-flex justify-content-center align-items-center ">
                         <span className="mb-0 mr-1 popup-title">Do you want to enable test mode ?</span>
                         <CButton color="primary" className="d-inline-block btn-cancel mr-1 pt-0 pb-0 p-4" onClick={handleCancel}>
                              No
                         </CButton>
                         <CButton color="success" className="d-inline-block pt-0 pb-0 p-4" onClick={() => handleEnabledTestMode()}>
                              Yes
                         </CButton>
                    </div>
               </CModalBody>
          </CModal>
     );
};

export default PopupEnabledTestMode;
